export default __webpack_public_path__ + "static/media/Inter-SemiBoldItalic.c632fb96.woff2";